<template>
    <div >
        <Intro />

        <UniqueApproach />

        <Testimonials />

        <OurDifference />

        <TheTeam />

        <ContactUs />
    </div>
</template>

<script>
    import Intro from '../components/Intro.vue';
    import ContactUs from '../components/ContactUs.vue';
    import UniqueApproach from '../components/UniqueApproach.vue';
    import Testimonials from '../components/Testimonials.vue';
    import OurDifference from '../components/OurDifference.vue';
    import TheTeam from '../components/TheTeam.vue';

    export default {
        name: 'Home',

        components: {
            Intro,
            TheTeam,
            OurDifference,
            Testimonials,
            UniqueApproach,
            ContactUs,
        },
    };
</script>

<style scoped>

</style>
